export const cabsLandingWidgetInfo = {
  HR_PACKAGES_WIDGET: 6,
  OUTSTATION_PICKUP_LOCATION_WIDGET: 7,
  OUTSTATION_DROP_LOCATION_WIDGET: 8,
  RENTAL_PICKUP_LOCATION_WIDGET: 9,
  FROM_AIRPORT_LOCATION_WIDGET: 10,
  FROM_AIRPORT_CITY_LOCATION_WIDGET: 11,
  STOPOVER_CITY_LOCATION_WIDGET: 12,
  TO_AIRPORT_LOCATION_WIDGET: 13,
  TO_AIRPORT_CITY_LOCATION_WIDGET: 14,
  NEW_DATE_TIME_PICKER: 15
};
